import script from "./AddFollowStep.vue?vue&type=script&setup=true&lang=js"
export * from "./AddFollowStep.vue?vue&type=script&setup=true&lang=js"

import "./AddFollowStep.vue?vue&type=style&index=0&id=54658281&scoped=true&lang=stylus"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54658281"]])

export default __exports__